import axios from 'axios';

const DEFAULT_BASE_URL = 'https://ubitz.ai/backend/api';
// const DEFAULT_BASE_URL = 'http://localhost/ubitz/api';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL ?? DEFAULT_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('API request failed:', error);
    }
    return Promise.reject(error);
  }
);

export default apiClient;

